module.exports = __webpack_public_path__ + "static/media/NICE_Step3a_Image15.e9f9f8de.jpg";